'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

///<reference path="../../../../typings/tsd.d.ts" />
var branches;
(function (branches) {
    var api = API.Client;

    var BranchesService = function () {
        /*@ngInject*/

        function BranchesService($http) {
            _classCallCheck(this, BranchesService);

            this.branchesAPI = new api.BranchesApi($http);
            this.saleTypesAPI = new api.SellTypesApi($http);
            this.sellersAPI = new api.SellersApi($http);
        }

        _createClass(BranchesService, [{
            key: 'getBanches',
            value: function getBanches() {
                return this.branchesAPI.branchesGet().then(function (response) {
                    response.data.branches.forEach(function (b) {
                        return b.name = b.cvcBranchCode + ' - ' + b.name;
                    });
                    return response.data.branches;
                });
            }
        }, {
            key: 'getSaleTypes',
            value: function getSaleTypes(branchCode) {
                return this.saleTypesAPI.sellTypesBranchCodeGet(branchCode).then(function (response) {
                    return response.data.SellTypes.SellType;
                });
            }
        }, {
            key: 'getSellers',
            value: function getSellers(branchCode, saleType) {
                return this.sellersAPI.sellerGet(branchCode, saleType, "S").then(function (response) {
                    return response.data.sellers;
                });
            }
        }]);

        return BranchesService;
    }();

    branches.BranchesService = BranchesService;
    angular.module('branches', []).service('branchesService', BranchesService);
})(branches || (branches = {}));